import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './thirteenthTaskSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import { memo, useEffect, useState } from 'react'
import { IAudio, IDraftAudio, ITask } from '../../../../../types/tasks.types'
import { ReactComponent as PlayIcon } from '../../../../../asserts/icons/play.svg'
import { ReactComponent as PauseIcon } from '../../../../../asserts/icons/pause.svg'
import { useRecoilValue } from 'recoil'
import sandboxAtom from '../../../sandbox.atom'
import { ReactComponent as RemoveIcon } from '../../../../../asserts/icons/xmark.svg'
import CreateAudioOptionModal from '../../CreateAudioOptionModal'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const ThirteenthTaskSandbox = (props: IProps) => {
  const { draftTask } = useRecoilValue(sandboxAtom)
  const [open, setOpen] = useState(false)

  const renderOptions = () => {
    return draftTask.audio.map((option, index) =>
      option.type === 'TASK_DESCRIPTION' ? null : (
        <AudioOption option={option} key={option.id ?? index} index={index} onDelete={handleOptionDelete} />
      )
    )
  }

  const handleOptionDelete = (index: number) => {
    props.onDraftTaskChange([...draftTask.audio.slice(0, index), ...draftTask.audio.slice(index + 1)] as any, 'audio')
  }

  const handleCreate = (option: IDraftAudio) => {
    props.onDraftTaskChange([...(draftTask.audio as any[]), option], 'audio')
    setOpen(false)
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      {open && <CreateAudioOptionModal onClose={() => setOpen(false)} onCreate={handleCreate} />}
      <LightLayout>
        <div className={css.wrapper} style={{ padding: '64px' }}>
          <div style={{ display: 'inline-flex', gap: '64px' }}>
            {renderOptions()}
            <div className={sandboxCss.addOption} onClick={() => setOpen(true)}>
              Добавить аудио
            </div>
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

const AudioOption = memo(
  ({ option, index, onDelete }: { option: IDraftAudio | IAudio; onDelete: (index: number) => void; index: number }) => {
    const [isPlaying, setIsPlaying] = useState(false)
    let url
    if (option.file instanceof File) {
      url = URL.createObjectURL(option.file)
    } else {
      url = option.file
    }

    useEffect(() => {
      if (!isPlaying) return
      if (!url) return

      const element = new Audio(url)
      element.addEventListener('ended', () => setIsPlaying(false))
      element.addEventListener('canplaythrough', () => element.play())

      return () => element.pause()
    }, [isPlaying])

    const togglePlay = (ev) => {
      ev.preventDefault()
      ev.stopPropagation()

      setIsPlaying((prev) => !prev)
    }

    const renderAudioPlayControls = () => {
      if (!url) return

      return !isPlaying ? (
        <PlayIcon onClick={togglePlay} className={css.playPauseIcon} />
      ) : (
        <PauseIcon onClick={togglePlay} className={css.playPauseIcon} />
      )
    }

    const fn = url ? (option as any)?.file?.name || decodeURI(url?.split('/')?.at(-1) ?? '') : ''

    return (
      <div style={{ width: '150px' }}>
        <div className={css.audioIcon} data-right-answer={option.rightAnswer} key={url}>
          {renderAudioPlayControls()}
          <RemoveIcon onClick={() => onDelete(index)} className={css.cancel} />
        </div>
        <p className="line-clamp-1" style={{ marginTop: '1em' }}>
          {fn}
        </p>
      </div>
    )
  }
)

export default ThirteenthTaskSandbox
